export default "__VITE_ASSET__tLWIaBRq__"